module.exports = __webpack_public_path__ + "img/banner.b460d109.jpg";